class CouponPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'coupon.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'coupon._m';

    // Access expired coupons
    static ACCESS_EXPIRED = 'coupon.access.expired';

    // Access deleted coupon
    static ACCESS_DELETED = 'coupon.access.deleted';

    // Access invalid coupon
    static ACCESS_INVALID = 'coupon.access.invalid';

    // Allow sync operation
    static SYNC = 'coupon.sync';
}

export default CouponPermission;
